import {
    authConstants
  } from "./../constants/auth-constants";
  

  const initialState = {
    commissionList: [],
    agentLimitList: [],
  };
  function configurationReducer(state  = initialState, action) {

    switch (action.type) {
      case authConstants.AGENT_LIMIT_LIST:
        return {
            ...state,
            agentLimitList: action.payload.data
          };

          case authConstants.COMMISSION_LIST:
        return {
            ...state,
            commissionList: action.payload.data
          };

      default:
        return state ;
    }
  };
  
  export default configurationReducer;